<template>
  <v-btn
    class="ma-2"
    :color="color"
    :loading="loading"
    dark
    depressed
    v-bind="$attrs"
    @click="printCheck"
    v-on="$listeners"
  >
    <slot>Печать чека</slot>
  </v-btn>
</template>

<script>
  export default {
    name: 'PrintCheckBtn',
    props: {
      orderId: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        default: 'success',
      },
    },
    data () {
      return {
        loading: false,
      }
    },
    methods: {
      async printCheck () {
        const payload = {
          type: this.type,
          orderId: this.orderId,
        }
        this.loading = true

        try {
          await this.$store.dispatch('orders/printingCheck', payload)
          this.showSuccessMessage('Чек отправлен на печать')
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.loading = false
      },
    },
  }
</script>

<style scoped lang="less">

</style>
